import React from "react";
import {
  BlockContainer,
  InnerBlockContainer,
  ContentContainer,
} from "BaseComponents/Wrappers";
import { H2 } from "BaseComponents/Text";
import { InfoItem } from "./InfoItem";
import { GetTextColor } from "Helpers/ColorHelper";

export const InfoBlock = ({ BackgroundColor, Heading, InfoItems }) => {
  const { textColor } = GetTextColor(BackgroundColor);
  return (
    <BlockContainer className={`infoblock ${!Heading ? 'withoutHeading' : ''}`} bgColor={`#${BackgroundColor}`}>
      <InnerBlockContainer>
        {!!Heading.length && (
          <H2 color={textColor} textAlign="center">
            {Heading}
          </H2>
        )}

        <ContentContainer
          className="contentContainer"
          justifyContent="center"
          flexWrap="wrap"
          margin="0 0 0 -15px"
        >
          {InfoItems.map((infoItem, key) => {
            return <InfoItem key={`infoitem-${key}`} {...infoItem} />;
          })}
        </ContentContainer>
      </InnerBlockContainer>
    </BlockContainer>
  );
};
